/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Loading_Team_DescriptionInputs */



/**
* | output |
* | --- |
* | "Configuring team access permissions." |
*
* @param {Spaces_Wizard_Loading_Team_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_loading_team_description = /** @type {((inputs?: Spaces_Wizard_Loading_Team_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Loading_Team_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team-Zugriffsberechtigungen werden konfiguriert.")
	return /** @type {LocalizedString} */ ("Configuring team access permissions.")
});